module.exports = __webpack_public_path__ + "static/img/teenpatt_en.04b3d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/teenpatt_en.png
// module id = NDHt
// module chunks = 1